import { Component, NgModule, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ipConfigAPI } from '../../../../assets/js/ipConfig.js';
import { RouterModule, Router, Routes, ActivatedRoute, NavigationEnd } from '@angular/router';
import { AuthService, AppInfoService, ScreenService } from '../../services/index';
import { DxFormModule, DxTooltipModule, DxTextBoxModule, DxCheckBoxModule, DxButtonModule, DxPopupModule, DxFormComponent, DxLoadIndicatorModule } from 'devextreme-angular';
import { CommonService } from '../../services/common.service';
import { CookieService } from 'ngx-cookie-service';
import { BaseRequestService } from '../../services/base-request.service';
import { FormsModule, NgForm } from '@angular/forms';
import { routerTransition } from '../../services/animations';
import { APIConfing } from '../../services/apiconfing.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgxSpinnerModule } from 'ngx-spinner';
import * as CryptoJS from 'crypto-js';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { CommonPreLoadedService } from 'src/app/core/services/common/common-pre-loaded.service';
import { CoreModule } from 'src/app/core/core.module';
import { Subscription } from 'rxjs';
import moment from 'moment';
import { ESSAccountVerifyModule } from 'src/app/shared/components/essaccount-verify/essaccount-verify.component';
import { ESSNewPasswordModule } from 'src/app/shared/components/essnew-password/essnew-password.component';
import { ForgotPasswordVerifyModule } from 'src/app/shared/components/forgot-password/forgot-password.component';
import { EncryptDecryptService } from 'src/app/shared/services/encrypt-decrypt.service';
import { NgOtpInputModule, NgOtpInputConfig, NgOtpInputComponent } from 'ng-otp-input';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  standalone: false,
  /* ,
  animations: [routerTransition()] */
})
export class LoginFormComponent implements OnInit, OnDestroy {
  @ViewChild('otpForm', { static: false }) otpFormInstance: DxFormComponent;
  @ViewChild(NgOtpInputComponent, { static: false }) ngOtpInput: NgOtpInputComponent;


  private ipAddress;
  isLogin: boolean = false;
  custLoginModel: any = {
    cid: 0,
    userName: '',
    password: '',
    userIP: '',
    userMAC: 'AS-TY-78-UI',
    isRemember: false,
    loginType: 1
  };

  verifyEmailMobileModel: any = { consEmailID: '', customerKey: '' };

  custLogin: any = {
    text: 'Login',
    useSubmitBehavior: true,
    width: '100%',
    type: 'success'
  };
  essContinue: any = {
    text: 'Continue',
    useSubmitBehavior: true,
    width: '100%',
    type: 'success'
  };
  private readonly LoginSubmitSpinner: string = 'LoginSubmitSpinner';
  emailButton: any;
  codeButton: any;
  passwordButton: any;
  SpinnerModal: any = { bdColor: '', fullScreen: false, size: '', color: '', type: '' };
  urlInfo: any = { cliConEmailID: '', clientContactID: '', cid: 0 };
  isValidAccount: boolean = false;
  isValidCompanyCode: boolean = false;
  setRespData: any = {};
  commonPatter: any = /^(\d{10}|\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6}))$/;
  isSubLogo: Subscription;
  isSubOD: Subscription;
  playStore: string = 'https://play.google.com/store/apps/details?id=app.ess.id';
  appleStore: string = 'https://apps.apple.com/in/app/staffinggo/id1556589714';
  displayAppLinks: boolean = false;
  isCompanyEmpCodeLogin: boolean = false;
  isEmailMobileLogin: boolean = true;
  getImgLogo: any;
  validEmailInfo: any;
  currentUrl: string;
  isShowImgLogo: boolean;
  ESSToken: any = [];
  isPassHide: boolean = false;
  isLoginShow: boolean = true;
  isVerifyShow: boolean = false;
  isForgotPassShow: boolean = false;
  verifyACC: any = {};
  passwordInputModel: any = {};
  isNewPasswordShow: boolean = false;
  attStatus: any = {};
  isBGImageEnabled: boolean = false;
  isRegisterLinkVisible: boolean = false;
  multipleCheckInfo: any = {};
  isMultipleLogin: boolean = false;
  isShowUserList: boolean = false;
  msg: any = '';
  isTwoFactorAuthEnabled: boolean = false;
  loginResponse: any = {};
  isOTPValidation: boolean = false;
  otpModal: any = {};
  SubmitOTP: any = {
    text: 'Submit',
    useSubmitBehavior: true,
    // onClick: this.fnSubmitOTP.bind(this),
    type: 'success',
    width: '100%'
  };
  CancelPopup: any = {
    text: 'Cancel',
    useSubmitBehavior: false,
    onClick: this.popup_hiding.bind(this),
    width: '100%'
  };
  ResendOTP: any = {
    text: 'Resend',
    useSubmitBehavior: false,
    onClick: this.fnResendOTP.bind(this),
    width: '100%'
  };

  isFullScreeen: boolean = true;
  footerImg: any;
  isWhiteLabled: any;


  constructor(private pageTitle: Title, public appInfo: AppInfoService, private baseRequset: BaseRequestService, private route: ActivatedRoute,
    public common: CommonService, private cookies: CookieService, private spinner: NgxSpinnerService,
    private authService: AuthService, private screen: ScreenService,
    private router: Router, private commonAPI: CommonPreLoadedService,
    private toastrService: ToastrService, private enc: EncryptDecryptService,) {
    if (APIConfing.data.isWhiteLabled != 'No') {
      pageTitle.setTitle(APIConfing.data.isWhiteLabled);
      this.isWhiteLabled = APIConfing.data.isWhiteLabled;
    }
    this.fnGetIPInfo();
    this.SpinnerModal.bdColor = APIConfing.data.spinnerProp.bdColor;
    this.SpinnerModal.fullScreen = APIConfing.data.spinnerProp.fullScreen;
    this.SpinnerModal.size = APIConfing.data.spinnerProp.size;
    this.SpinnerModal.type = APIConfing.data.spinnerProp.type;
    this.SpinnerModal.color = APIConfing.data.spinnerProp.color;
    this.isBGImageEnabled = APIConfing.data.isBGImageEnabled;
    this.isRegisterLinkVisible = APIConfing.data.isRegisterLinkVisible;
    this.footerImg = APIConfing.data.footerConfig.footerImg;
    this.playStore = APIConfing.data.apiConfing.playStoreURL || 'https://play.google.com/store/apps/details?id=app.ess.id';
    this.appleStore = APIConfing.data.apiConfing.appleStoreURL || 'https://apps.apple.com/in/app/staffinggo/id1556589714';

    this.filterDrawer();
    this.screen.changed.subscribe((obj) => {
      this.filterDrawer();
    });

    this.route.queryParams.subscribe(async params => {
      if (params && params.SSInfo) {
        const getToken: any = { Credentials: params.SSInfo }
        const getResp = await this.getActiveToken(getToken);
        if (getResp) {
          this.fnGetSessionDS({});
        } else {
          this.toastrService.error(APIConfing.data.E002, 'Error');
        }
      }
    });

    this.route.queryParams.subscribe(params => {
      if (params && params.userName && params.cid && params.consultantID) {
        this.custLoginModel.userName = atob(params.userName);
        this.isValidAccount = true;
        this.setRespData.cid = parseInt(atob(params.cid));
        this.custLoginModel.cid = this.setRespData.cid;
        this.setRespData.consultantID = atob(params.consultantID);
        if (this.cookies.get('crd')) {
          const setData = this.common.fnCheckCookie(this.cookies.get('crd'));
          if (this.custLoginModel.userName === setData.userName) {
            this.custLoginModel = setData;
            this.custLoginModel.cid = this.setRespData.cid;
          }
        }
        if (this.setRespData.cid > 0) {
          // this.commonAPI.fnGetCustomerLogoURL(this.setRespData.cid, 2);
          this.getImgLogo = localStorage.getItem(this.enc.encryptUsingAES256('customerLogoURL'));
          this.fnGetMobileAppUrls(parseInt(atob(params.cid)));
        } else {
          this.isShowImgLogo = false;
        }
      } else if (params && params.consultantID && params.cid) {
        this.isValidAccount = true;
        this.setRespData.cid = parseInt(atob(params.cid));
        this.custLoginModel.cid = this.setRespData.cid;
        this.setRespData.consultantID = atob(params.consultantID);
        if (this.setRespData.cid > 0) {
          // this.commonAPI.fnGetCustomerLogoURL(this.setRespData.cid, 2);
          this.getImgLogo = localStorage.getItem(this.enc.encryptUsingAES256('customerLogoURL'));
          this.isShowImgLogo = true;
          this.fnGetMobileAppUrls(parseInt(atob(params.cid)));
        } else {
          this.isShowImgLogo = false;
        }
      } else if (params && params.cid && params.loginType) {
        if (params.loginType == 'EmpID') {
          this.fnLoginByType(1);
        }
        this.setRespData.cid = parseInt(atob(params.cid));
        this.custLoginModel.cid = this.setRespData.cid;
        if (this.setRespData.cid) {
          if (this.setRespData.cid > 0) {
            // this.commonAPI.fnGetCustomerLogoURL(this.setRespData.cid, 2);
            this.getImgLogo = localStorage.getItem(this.enc.encryptUsingAES256('customerLogoURL'));
            this.isShowImgLogo = true;
            this.fnGetMobileAppUrls(parseInt(atob(params.cid)));
          } else {
            this.isShowImgLogo = false;
          }
        } else {
          this.isValidAccount = false;
          this.setRespData.cid = atob(params.cid);
          this.custLoginModel.cid = this.setRespData.cid;
          if (this.setRespData.cid > 0) {
            // this.commonAPI.fnGetCustomerLogoURL(this.setRespData.cid, 2);
            this.getImgLogo = localStorage.getItem(this.enc.encryptUsingAES256('customerLogoURL'));
            this.isShowImgLogo = true;
          } else {
            this.isShowImgLogo = false;
          }
        }
      } else if (params && params.cid) {
        this.setRespData.cid = parseInt(atob(params.cid));
        this.custLoginModel.cid = this.setRespData.cid;
        if (this.setRespData.cid) {
          if (this.setRespData.cid > 0) {
            // this.commonAPI.fnGetCustomerLogoURL(this.setRespData.cid, 2);
            this.getImgLogo = localStorage.getItem(this.enc.encryptUsingAES256('customerLogoURL'));
            this.isShowImgLogo = true;
            this.fnGetMobileAppUrls(parseInt(atob(params.cid)));
          } else {
            this.isShowImgLogo = false;
          }
        } else {
          this.isValidAccount = false;
          this.setRespData.cid = atob(params.cid);
          this.custLoginModel.cid = this.setRespData.cid;
          if (this.setRespData.cid > 0) {
            // this.commonAPI.fnGetCustomerLogoURL(this.setRespData.cid, 2);
            this.getImgLogo = localStorage.getItem(this.enc.encryptUsingAES256('customerLogoURL'));
            this.isShowImgLogo = true;
          } else {
            this.isShowImgLogo = false;
          }
        }
      } else if (params) {
        this.isShowImgLogo = false;
      } else {
        this.isValidAccount = false;
      }
    });

    this.emailButton = {
      icon: 'assets/Assets/Login_Icons/Edit_icon.svg',
      hint: 'Click here, to change email ID',
      type: 'default',
      onClick: (e) => { this.isValidAccount = false; },
      disabled: false
    };

    this.codeButton = {
      icon: 'assets/Assets/Login_Icons/Edit_icon.svg',
      hint: 'Click here, to change code',
      type: 'default',
      onClick: (e) => { this.isValidCompanyCode = false; },
      disabled: false
    };

    this.passwordButton = {
      icon: this.isPassHide ? 'assets/Assets/Login_Icons/Hide.svg' : 'assets/Assets/Login_Icons/Unhide.svg',
      hint: 'Click here, to view password',
      type: 'default',
      onClick: (e) => { this.fnShowHidePass(); }
    }
    if (sessionStorage.getItem(this.enc.encryptUsingAES256('esstoken'))) {

      const isLogin: any = this.common.fnGetAuthInfo();
      if (isLogin && isLogin.length > 0) {
        if ((isLogin[0].isESS === 'ESS') && (isLogin[0].restrictEmpLogin)) {
          this.router.navigate(['/Offer-Acceptance']);
        } else if ((isLogin[0].isESS === 'ESS') && (isLogin[0].restrictEmpLogin !== 1)) {
          this.router.navigate(['/ESS-Home']);
        } else {
          this.router.navigate(['/home']);
        }
      }
    } else if (sessionStorage.getItem(this.enc.encryptUsingAES256('urlData'))) {
      const getURLData = JSON.parse(sessionStorage.getItem('urlData'));
      this.urlInfo.cid = getURLData.cid;
      this.router.navigate(['/login'],
        { queryParams: { cid: getURLData.cid } });
    } else {
      if (!this.setRespData.cid) {
        this.router.navigate(['/login']);
      }
    }

    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
        if (this.currentUrl === '/login') {
          this.isValidAccount = false;
        }
      }
    });

    this.isSubLogo = this.commonAPI.getCustomerLogo$().pipe(catchError(err => throwError(err))).subscribe(obj => {
      if (obj && obj.length > 0) {
        this.getImgLogo = obj[0].logoURL;
        this.isShowImgLogo = true;
        this.commonAPI.sendTitle(obj[0].customerTitle);
        this.commonAPI.customerLogo.next(null);
      } else if (obj && obj.length === 0) {
        this.isShowImgLogo = false;
        this.getImgLogo = null;
      }
    });

    this.isSubOD = this.commonAPI.getConsAttendanceStatus$().pipe(catchError(err => throwError(err))).subscribe(obj => {
      if (obj && obj.length > 0) {
        this.attStatus = obj[0];
        this.fnCheckAttendance();
        this.commonAPI.attendanceStatus.next(null);
      } else if (obj && obj.length === 0) {
        this.commonAPI.attendanceStatus.next(null);
      }
    });
  }

  ngOnInit() {
    this.fnGetCommonQuotes();

  }

  ngOnDestroy() {
    this.isValidAccount = false;
    this.displayAppLinks = false;
    this.isSubLogo.unsubscribe();
    this.isSubOD.unsubscribe();
  }

  async fnGetIPInfo() {
    await ipConfigAPI().then(data => { this.ipAddress = data; this.custLoginModel.userIP = this.ipAddress.ip; });
  }

  commonQuotesArr: any = [];
  fnGetCommonQuotes() {
    this.baseRequset.fnpost('/CSS/Consultant/GetCommonQuotes', {}).subscribe((dataRESP: any) => {
      if (dataRESP && dataRESP.code === this.baseRequset.status.success) {
        this.commonQuotesArr = dataRESP.dataObject;
      } else if (dataRESP && dataRESP.code === 'L002') {
        this.toastrService.error(dataRESP.message);
      } else if (dataRESP.code === 'E002') {
        this.toastrService.error(APIConfing.data.E002);
      } else if (dataRESP.code === 'E001') {
        this.toastrService.error(dataRESP.message, 'Error');
      } else if (dataRESP.code === this.baseRequset.warning.code) {
        this.toastrService.warning(dataRESP.message, 'Details');
      } else {
        this.commonQuotesArr = [];
      }
    }, err => {
      this.toastrService.error(APIConfing.data.E002);
    });
  }

  filterDrawer() {
    const isXSmall = this.screen.sizes['screen-x-small'];
    const isSmall = this.screen.sizes['screen-small'];
    const isMedium = this.screen.sizes['screen-medium'];
    const isLarge = this.screen.sizes['screen-large'];
    if (isXSmall || isSmall) {
      this.isFullScreeen = false;
    } else if (isMedium || isLarge) {
      this.isFullScreeen = true;
    } else {
      this.isFullScreeen = true;
    }
  }

  fnShowHidePass() {
    this.isPassHide = !this.isPassHide;
    this.passwordButton.icon = this.isPassHide ? 'assets/Assets/Login_Icons/Hide.svg' : 'assets/Assets/Login_Icons/Unhide.svg';
  }



  fnNavToReg() {
    this.router.navigate(['/register'], { queryParams: { cid: btoa(this.setRespData.cid) } });
  }



  /* new UI  */





  fnLoginByType(ctrl) {
    if (ctrl == 1) {
      this.isCompanyEmpCodeLogin = true;
      this.isEmailMobileLogin = false;
      this.verifyEmailMobileModel = { consEmailID: '', customerKey: '' };
    } else if (ctrl == 2) {
      this.isCompanyEmpCodeLogin = false;
      this.isEmailMobileLogin = true;
      this.verifyEmailMobileModel = { consEmailID: '', customerKey: '' };
    } else {
      this.isCompanyEmpCodeLogin = false;
      this.isEmailMobileLogin = true;
    }
  }


  loadIndicatorVisible = false;
  /**.......Email_Validate......>........**/
  fnValidCustomer(data: any, formTypeCtrl) {
    this.loadIndicatorVisible = true;
    data.formType = formTypeCtrl;
    this.baseRequset.fnpost('/CSS/Consultant/GetValidateConsultantEMailID', data).subscribe((dataRESP: any) => {
      if (dataRESP && dataRESP.code === this.baseRequset.status.success) {
        this.loadIndicatorVisible = false;
        const response = JSON.parse(this.enc.decryptUsingAES256(dataRESP.dataObject));
        this.isMultipleLogin = response && response.isMultiple > 0 ? true : false;
        const tempData: any = dataRESP;
        tempData.dataObject = response;
        this.multipleCheckInfo = tempData;
        this.fnCheckLogin(formTypeCtrl);
      } else if (dataRESP && dataRESP.code === 'L002') {
        this.toastrService.error(dataRESP.message);
        this.loadIndicatorVisible = false;
      } else if (dataRESP.code === 'E002') {
        this.toastrService.error(APIConfing.data.E002);
        this.loadIndicatorVisible = false;
      } else if (dataRESP.code === 'E001') {
        this.toastrService.error(dataRESP.message, 'Error');
        this.loadIndicatorVisible = false;
      } else if (dataRESP.code === this.baseRequset.warning.code) {
        this.toastrService.warning(dataRESP.message, 'Details');
        this.loadIndicatorVisible = false;
      } else {
        this.loadIndicatorVisible = false;
      }
    }, err => {
      this.toastrService.error(APIConfing.data.E002);
      this.loadIndicatorVisible = false;
    });
  }

  fnCheckLogin(formTypeCtrl) {
    if (this.isMultipleLogin) {
      this.isShowUserList = true;
      this.multipleCheckInfo.dataObject.userList.forEach(element => {
        element.eMailID = this.multipleCheckInfo.dataObject.eMailID;
      });
    } else {
      this.isTwoFactorAuthEnabled = this.multipleCheckInfo.dataObject.enableTwoFactorAuth > 0 ? true : false;
      this.getImgLogo = this.multipleCheckInfo.dataObject.userList[0].customerLogoURL;
      localStorage.setItem(this.enc.encryptUsingAES256('customerLogoURL'), this.getImgLogo);
      this.isShowImgLogo = true;
      if (this.multipleCheckInfo && this.multipleCheckInfo.dataObject.regStatus === 0) {
        this.toastrService.error(this.multipleCheckInfo.message);
        this.spinner.hide(this.LoginSubmitSpinner);
      } else if (this.multipleCheckInfo && this.multipleCheckInfo.dataObject.regStatus === 1) {
        this.spinner.hide(this.LoginSubmitSpinner);
        this.verifyACC = {
          cid: this.multipleCheckInfo.dataObject.cid,
          consultantID: this.multipleCheckInfo.dataObject.consultantID,
          regStatus: this.multipleCheckInfo.dataObject.regStatus,
          consEmailID: this.verifyEmailMobileModel.consEmailID
        }
        this.isVerifyShow = true;
        this.isLoginShow = false;
        this.isNewPasswordShow = false;
        this.isForgotPassShow = false;
      } else if (this.multipleCheckInfo && this.multipleCheckInfo.dataObject.regStatus === 2) {
        this.custLoginModel.userName = this.verifyEmailMobileModel.consEmailID;
        this.custLoginModel.customerKey = this.verifyEmailMobileModel.customerKey;
        this.setRespData = this.multipleCheckInfo.dataObject.userList[0];
        this.custLoginModel.cid = this.setRespData.cid;
        this.router.navigate(['/login'], { queryParams: { cid: btoa(this.multipleCheckInfo.dataObject.cid), } });
        if (formTypeCtrl == 1) {
          this.isValidAccount = true;
        } else if (formTypeCtrl == 2) {
          this.isValidCompanyCode = true;
        }
        this.fnGetMobileAppUrls(this.multipleCheckInfo.dataObject.cid);
        this.spinner.hide(this.LoginSubmitSpinner);
      } else {
        if (formTypeCtrl == 1) {
          this.isValidAccount = false;
        } else if (formTypeCtrl == 2) {
          this.isValidCompanyCode = false;
        }
        this.toastrService.error(this.multipleCheckInfo.message, 'Error');
      }
    }
  }

  /**.......Email_Validate......<........**/





  /**.......Select_Customer......>........**/
  fnSelectLogin(item) {
    this.isShowUserList = false;
    this.isTwoFactorAuthEnabled = item.enableTwoFactorAuth;
    this.getImgLogo = item.customerLogoURL;
    localStorage.setItem(this.enc.encryptUsingAES256('customerLogoURL'), this.getImgLogo);
    this.isShowImgLogo = true;
    if (item && item.regStatus === 0) {
      this.toastrService.error(this.multipleCheckInfo.message);
      this.spinner.hide(this.LoginSubmitSpinner);
    } else if (item && item.regStatus === 1) {
      this.spinner.hide(this.LoginSubmitSpinner);
      this.verifyACC = {
        cid: item.cid,
        consultantID: item.consultantID,
        regStatus: item.regStatus,
        consEmailID: this.verifyEmailMobileModel.consEmailID
      }
      this.isVerifyShow = true;
      this.isLoginShow = false;
      this.isNewPasswordShow = false;
      this.isForgotPassShow = false;
    } else if (item && item.regStatus === 2) {
      this.custLoginModel.userName = this.verifyEmailMobileModel.consEmailID;
      this.setRespData = item;
      this.custLoginModel.cid = this.setRespData.cid;
      this.router.navigate(['/login'], { queryParams: { cid: btoa(item.cid), } });
      this.isValidAccount = true;
      this.fnGetMobileAppUrls(item.cid);
      this.spinner.hide(this.LoginSubmitSpinner);
    } else {
      this.isValidAccount = false;
      this.toastrService.error(this.multipleCheckInfo.message, 'Error');
    }
  }

  fnBackToLogIn() {
    this.isShowUserList = false;
  }

  fnGetMobileAppUrls(cid) {
    this.displayAppLinks = true;
    const obj = { cid: cid }
    this.baseRequset.fnpost('/CSS/Consultant/GetCustomerURLDetails', this.common.fnReturnEncryptedPayload(obj)).subscribe((dataRESP: any) => {
      if (dataRESP && dataRESP.code === this.baseRequset.status.success) {
        const res = this.common.fnReturnDecryptedResponse(dataRESP.dataObject);
        if (res && res.length) {
          if (res[0].androidAppPath) {
            this.playStore = res[0].androidAppPath;
          }
          if (res[0].androidAppPath) {
            this.appleStore = res[0].iosAppPath;
          }
        }
      } else if (dataRESP && dataRESP.code === 'L002') {
        this.toastrService.error(dataRESP.message);
      } else if (dataRESP.code === 'E002') {
        this.toastrService.error(APIConfing.data.E002);
      } else if (dataRESP.code === 'E001') {
        this.toastrService.error(dataRESP.message, 'Error');
      } else if (dataRESP.code === this.baseRequset.warning.code) {
        this.toastrService.warning(dataRESP.message, 'Details');
      } else {
      }
    }, err => {
      this.toastrService.error(APIConfing.data.E002);
    });
  }

  /**.......Select_Customer......<........**/







  /**.......Password_Validate......>........**/
  async fnConsLoginSubmit(data: any) {
    data.cid = data.cid ? parseInt(data.cid) : 0;
    data.consultantID = this.setRespData.consultantID ? this.setRespData.consultantID : 0;
    data.staffingID = this.setRespData.staffingID ? this.setRespData.staffingID : 0;
    this.loadIndicatorVisible = true;
    if (data) {
      const getAuthResp: any = await this.baseRequset.fnpost('/Auth/authenticate', this.common.fnReturnEncryptedPayload(data)).toPromise();
      try {
        if (getAuthResp && getAuthResp.data && getAuthResp.data.token) {
          this.ESSToken = getAuthResp.data.token;
          sessionStorage.setItem(this.enc.encryptUsingAES256('ESS_token'), getAuthResp.data.token);
          sessionStorage.setItem(this.enc.encryptUsingAES256('ESS_Refresh_token'), getAuthResp.data.refreshToken);
          localStorage.setItem(this.enc.encryptUsingAES256('ESS_token'), getAuthResp.data.token);
          if (getAuthResp.data.token) {
            this.fnGetSessionDS(data);
          } else {
            this.toastrService.error(APIConfing.data.E002, 'Error');
            this.loadIndicatorVisible = false;
          }
          return true;
        } else if (getAuthResp.code === 'L002') {
          this.toastrService.error(getAuthResp.message, 'Error');
          this.loadIndicatorVisible = false;
          return false;
        } else if (getAuthResp.code === 'E002') {
          this.toastrService.error(APIConfing.data.E002);
          this.loadIndicatorVisible = false;
          return false;
        } else if (getAuthResp.code === 'E001') {
          this.toastrService.error(getAuthResp.message, 'Error');
          this.loadIndicatorVisible = false;
        } else if (getAuthResp.code === this.baseRequset.warning.code) {
          this.toastrService.warning(getAuthResp.message, 'Details');
          this.loadIndicatorVisible = false;
          return false;
        } else {
          this.loadIndicatorVisible = false;
          return false;
        }
      } catch (error) {
        this.toastrService.error(APIConfing.data.E002, 'Error');
        this.loadIndicatorVisible = false;
        return false;
      }
    }
  }

  fnGetSessionDS(data) {
    const SessionData: any = {};
    this.baseRequset.fnpost('/CSS/Consultant/GetConsultantSessionDetails', SessionData).subscribe((dataRESP: any) => {
      if (dataRESP && dataRESP.code === this.baseRequset.status.success) {
        this.loginResponse = dataRESP;
        if (this.isTwoFactorAuthEnabled) {
          this.loadIndicatorVisible = false;
          this.fnSendOTP();
        } else {
          const response = JSON.parse(this.enc.decryptUsingAES256(dataRESP.dataObject));
          if (response[0].isMyBirthDay) {
            localStorage.setItem(this.enc.encryptUsingAES256('isMyBirthDay'), btoa(response[0].isMyBirthDay));
          } else localStorage.setItem('isMyBirthDay', btoa('0'));
          this.common.fnIsSetCookies(data);

          response[0].ESSToken = this.ESSToken;
          sessionStorage.setItem(this.enc.encryptUsingAES256('esstoken'), dataRESP.dataObject);
          this.loadIndicatorVisible = false;
          if (response[0].isESS === 'ESS') {
            if ((response[0].isOfferReleased === 1 || response[0].isHRLetterReleased === 1 || response[0].isAssetLetterReleased === 1) || (response[0].restrictEmpLogin)) {
              const pwdInfo: any = { requiredPwdChange: this.requiredPwdChange, passwordInputModel: this.passwordInputModel };
              this.router.navigate(['/Offer-Acceptance'], { queryParams: { isPasswdInfo: btoa(JSON.stringify(pwdInfo)), } });
            } else {
              const pwdInfo: any = { requiredPwdChange: this.requiredPwdChange, passwordInputModel: this.passwordInputModel };
              this.router.navigate(['/ESS-Home'], { queryParams: { isPasswdInfo: btoa(JSON.stringify(pwdInfo)), } });
            }
          } else {
            if ((response[0].isOfferReleased === 1 || response[0].isHRLetterReleased === 1 || response[0].isAssetLetterReleased === 1) || (response[0].restrictEmpLogin)) {
              const pwdInfo: any = { requiredPwdChange: this.requiredPwdChange, passwordInputModel: this.passwordInputModel };
              this.router.navigate(['/Offer-Acceptance'], { queryParams: { isPasswdInfo: btoa(JSON.stringify(pwdInfo)), } });
            } else {
              const pwdInfo: any = { requiredPwdChange: this.requiredPwdChange, passwordInputModel: this.passwordInputModel };
              this.router.navigate(['/home'], { queryParams: { isPasswdInfo: btoa(JSON.stringify(pwdInfo)), } });
            }
          }
        }
      } else if (dataRESP.code === 'E002') {
        this.toastrService.error(APIConfing.data.E002);
        this.loadIndicatorVisible = false;
      } else if (dataRESP.code === 'E001') {
        this.toastrService.error(dataRESP.message, 'Error');
        this.loadIndicatorVisible = false;
      } else if (dataRESP.code === this.baseRequset.warning.code) {
        this.toastrService.warning(dataRESP.message, 'Details');
        this.loadIndicatorVisible = false;
      } else {
        this.loadIndicatorVisible = false;
      }
    }, error => {
      this.toastrService.error(APIConfing.data.E002, 'Error');
      this.loadIndicatorVisible = false;
    });
  }


  /**.......Password_Validate......<........**/





  /**.......OTP_Validate......>........**/
  fnSendOTP() {
    this.spinner.show('otpSpinner');
    this.baseRequset.fnpost('/CSS/Consultant/ESSSendCandOTP', {}).subscribe((dataRESP: any) => {
      if (dataRESP && dataRESP.code === this.baseRequset.status.success) {
        this.msg = dataRESP.message || '';
        this.isOTPValidation = true;
        this.toastrService.success(dataRESP.message, 'success');
        this.resendDisabled = true;
        this.timer = 20;
        this.intervalRef = setInterval(() => {
          this.timer--;
          if (this.timer <= 0) {
            this.resendDisabled = false;
            clearInterval(this.intervalRef);
          }
        }, 1000);
        this.spinner.hide('otpSpinner');
      } else if (dataRESP.code === 'E002') {
        this.spinner.hide('otpSpinner');
        this.toastrService.error(APIConfing.data.E002);
      } else if (dataRESP.code === 'E001') {
        this.toastrService.error(dataRESP.message, 'Error');
        this.spinner.hide('otpSpinner');
      } else if (dataRESP.code === this.baseRequset.warning.code) {
        this.toastrService.warning(dataRESP.message, 'Details');
        this.spinner.hide('otpSpinner');
      } else {
        this.spinner.hide('otpSpinner');
      }
    }, error => {
      this.spinner.hide('otpSpinner');
      this.toastrService.error(APIConfing.data.E002, 'Error');
    });
  }

  fnSubmitOTP() {
    // const val = this.otpFormInstance.instance.validate();
    if (this.otpModal.otp && this.otpModal.otp.length === 6) {
      this.spinner.show(this.LoginSubmitSpinner);
      this.loadIndicatorVisible = true;
      this.baseRequset.fnpost('/CSS/Consultant/ValidateCandOTP', this.otpModal).subscribe((dataRESP: any) => {
        if (dataRESP && dataRESP.code === this.baseRequset.status.success) {
          // this.isOTPValidation = false;
          this.loadIndicatorVisible = false;
          sessionStorage.setItem(this.enc.encryptUsingAES256('esstoken'), this.loginResponse.dataObject);
          this.toastrService.success(dataRESP.message, 'success');
          const loginResponseObj = JSON.parse(this.enc.decryptUsingAES256(this.loginResponse.dataObject));
          loginResponseObj[0].ESSToken = this.ESSToken;
          if (loginResponseObj[0].isMyBirthDay) {
            localStorage.setItem(this.enc.encryptUsingAES256('isMyBirthDay'), btoa(loginResponseObj[0].isMyBirthDay));
          } else localStorage.setItem('isMyBirthDay', btoa('0'));
          if (loginResponseObj[0].isESS === 'ESS') {
            this.spinner.hide(this.LoginSubmitSpinner);
            if ((loginResponseObj[0].isOfferReleased === 1 || loginResponseObj[0].isHRLetterReleased === 1 || loginResponseObj[0].isAssetLetterReleased === 1) || (loginResponseObj[0].restrictEmpLogin)) {
              this.router.navigate(['/Offer-Acceptance']);
            } else {
              this.router.navigate(['/ESS-Home']);
            }
          } else {
            this.spinner.hide(this.LoginSubmitSpinner);
            if ((loginResponseObj[0].isOfferReleased === 1 || loginResponseObj[0].isHRLetterReleased === 1 || loginResponseObj[0].isAssetLetterReleased === 1) || (loginResponseObj[0].restrictEmpLogin)) {
              this.router.navigate(['/Offer-Acceptance']);
            } else {
              this.router.navigate(['/home']);
            }
          }
        } else if (dataRESP.code === 'E002') {
          this.loadIndicatorVisible = false;
          this.spinner.hide(this.LoginSubmitSpinner);
          this.toastrService.error(APIConfing.data.E002);
        } else if (dataRESP.code === 'E001') {
          this.loadIndicatorVisible = false;
          this.toastrService.error(dataRESP.message, 'Error');
          this.spinner.hide(this.LoginSubmitSpinner);
        } else if (dataRESP.code === this.baseRequset.warning.code) {
          this.loadIndicatorVisible = false;
          this.toastrService.warning(dataRESP.message, 'Details');
          this.spinner.hide(this.LoginSubmitSpinner);
        } else {
          this.loadIndicatorVisible = false;
          this.spinner.hide(this.LoginSubmitSpinner);
        }
      }, error => {
        this.loadIndicatorVisible = false;
        this.toastrService.error(APIConfing.data.E002, 'Error');
        this.spinner.hide(this.LoginSubmitSpinner);
      });
    } else {
      this.toastrService.error(APIConfing.data.isValid, 'Error');
    }
  }

  fnResendOTP() {
    this.fnSendOTP();
  }

  popup_hiding() {
    this.otpFormInstance.instance.resetValues();
    this.isOTPValidation = false;
    // this.authService.logout();
  }

  /**.......OTP_Validate......<........**/






  /**.......GET_Active_Token......>........**/
  async getActiveToken(data: any) {
    this.spinner.show(this.LoginSubmitSpinner);
    if (data) {
      const getAuthResp: any = await this.baseRequset.fnpost('/CSS/Consultant/ValidateConsCredentials', data).toPromise();
      try {
        if (getAuthResp && getAuthResp.data && getAuthResp.data.token) {
          this.spinner.hide(this.LoginSubmitSpinner);
          this.ESSToken = getAuthResp.data.token;
          sessionStorage.setItem(this.enc.encryptUsingAES256('ESS_token'), getAuthResp.data.token);
          sessionStorage.setItem(this.enc.encryptUsingAES256('ESS_Refresh_token'), getAuthResp.data.refreshToken);
          localStorage.setItem(this.enc.encryptUsingAES256('ESS_token'), getAuthResp.data.token);
          this.spinner.hide(this.LoginSubmitSpinner);
          return true;
        } else if (getAuthResp.code === 'L002') {
          this.toastrService.error(getAuthResp.message, 'Error');
          this.spinner.hide(this.LoginSubmitSpinner);
          return false;
        } else if (getAuthResp.code === 'E002') {
          this.toastrService.error(APIConfing.data.E002);
          this.spinner.hide(this.LoginSubmitSpinner);
          return false;
        } else if (getAuthResp.code === 'E001') {
          this.toastrService.error(getAuthResp.message, 'Error');
          this.spinner.hide(this.LoginSubmitSpinner);
        } else if (getAuthResp.code === this.baseRequset.warning.code) {
          this.toastrService.warning(getAuthResp.message, 'Details');
          this.spinner.hide(this.LoginSubmitSpinner);
          return false;
        } else {
          this.spinner.hide(this.LoginSubmitSpinner);
          return false;
        }
      } catch (error) {
        this.toastrService.error(APIConfing.data.E002, 'Error');
        this.spinner.hide(this.LoginSubmitSpinner);
        return false;
      }

    }
  }

  /**.......GET_Active_Token......<........**/






  /**.......fn_Reset_Password......>........**/
  fnResetPassword() {
    this.validEmailInfo = { consEmailID: this.custLoginModel.userName, consultantID: this.setRespData.consultantID, cid: this.setRespData.cid, route: 'Verify-Account' };
    this.isLoginShow = false;
    this.isVerifyShow = false;
    this.isNewPasswordShow = false;
    this.isForgotPassShow = true;
  }
  /**.......fn_Reset_Password......<........**/




  fnCheckAttendance() {
    if (this.attStatus && this.attStatus.attendanceStatus === 1 || this.attStatus.attendanceStatus === 2 || this.attStatus.attendanceStatus === -1) {
      this.router.navigate(['/sign-in']);
    } else {
      this.router.navigate(['/ESS-Home']);
    }

  }


  fnGetNewPass(e) {
    if (e) {
      this.isLoginShow = true;
      this.isForgotPassShow = false;
      this.isVerifyShow = false;
      this.isNewPasswordShow = false;
    }
  }


  fnGetPassRes(e) {
    if (e && e.route == 'Verify-Account') {
      this.verifyACC.consEmailID = e.consEmailID;
      this.verifyACC.cid = e.cid;
      this.verifyACC.consultantID = e.consultantID;
      this.verifyACC.msg = e.msg || '';
      this.isLoginShow = false;
      this.isVerifyShow = true;
      this.isForgotPassShow = false;
      this.isNewPasswordShow = false;
    } else if (e && e.route == 'Login') {
      this.isLoginShow = true;
      this.isVerifyShow = false;
      this.isForgotPassShow = false;
      this.isNewPasswordShow = false;
      if (e && e.userName && e.cid && e.consultantID) {
        this.custLoginModel.userName = e.userName;
        this.isValidAccount = true;
        this.setRespData.cid = e.cid;
        this.custLoginModel.cid = this.setRespData.cid;
        this.setRespData.consultantID = e.consultantID;
        if (this.cookies.get('crd')) {
          const setData = this.common.fnCheckCookie(this.cookies.get('crd'));
          if (this.custLoginModel.userName === setData.userName) {
            this.custLoginModel = setData;
            this.custLoginModel.cid = this.setRespData.cid;
          }
        }
        if (this.setRespData.cid > 0) {
          // this.commonAPI.fnGetCustomerLogoURL(this.setRespData.cid, 2);
          this.getImgLogo = localStorage.getItem(this.enc.encryptUsingAES256('customerLogoURL'));
          this.isShowImgLogo = true;
          this.fnGetMobileAppUrls(e.cid);
        } else {
          this.isShowImgLogo = false;
        }
      } else if (e && e.consultantID && e.cid) {
        this.isValidAccount = true;
        this.setRespData.cid = e.cid;
        this.custLoginModel.cid = this.setRespData.cid;
        this.setRespData.consultantID = e.consultantID;
        if (this.setRespData.cid > 0) {
          // this.commonAPI.fnGetCustomerLogoURL(this.setRespData.cid, 2);
          this.getImgLogo = localStorage.getItem(this.enc.encryptUsingAES256('customerLogoURL'));
          this.isShowImgLogo = true;
          this.fnGetMobileAppUrls(e.cid);
        } else {
          this.isShowImgLogo = false;
        }
      } else if (e && e.cid) {
        this.isValidAccount = false;
        this.setRespData.cid = e.cid;
        this.custLoginModel.cid = this.setRespData.cid;
        if (this.setRespData.cid > 0) {
          // this.commonAPI.fnGetCustomerLogoURL(this.setRespData.cid, 2);
          this.getImgLogo = localStorage.getItem(this.enc.encryptUsingAES256('customerLogoURL'));
          this.isShowImgLogo = true;
          this.fnGetMobileAppUrls(e.cid);
        } else {
          this.isShowImgLogo = false;
        }
      } else if (e) {
        this.isShowImgLogo = false;
      } else {
        this.isValidAccount = false;
      }

    }
  }

  requiredPwdChange: boolean = false;
  fnGetRes(e) {
    if (e && e.route == 'New-Password') {
      this.passwordInputModel.consEmailID = e.consEmailID;
      this.passwordInputModel.cid = e.cid;
      this.passwordInputModel.consultantID = e.consultantID;
      this.requiredPwdChange = true;
      this.custLoginModel.password = e.otp;
      this.fnConsLoginSubmit(this.custLoginModel);
    } else if (e && e.route == 'Login') {
      this.isLoginShow = true;
      this.isVerifyShow = false;
      this.isNewPasswordShow = false;
      this.isForgotPassShow = false;
      if (e && e.userName && e.cid && e.consultantID) {
        this.custLoginModel.userName = e.userName;
        this.isValidAccount = true;
        this.setRespData.cid = e.cid;
        this.custLoginModel.cid = this.setRespData.cid;
        this.setRespData.consultantID = e.consultantID;
        if (this.cookies.get('crd')) {
          const setData = this.common.fnCheckCookie(this.cookies.get('crd'));
          if (this.custLoginModel.userName === setData.userName) {
            this.custLoginModel = setData;
            this.custLoginModel.cid = this.setRespData.cid;
          }
        }
        if (this.setRespData.cid > 0) {
          // this.commonAPI.fnGetCustomerLogoURL(this.setRespData.cid, 2);
          this.getImgLogo = localStorage.getItem(this.enc.encryptUsingAES256('customerLogoURL'));
          this.isShowImgLogo = true;
        } else {
          this.isShowImgLogo = false;
        }
      } else if (e && e.consultantID && e.cid) {
        this.isValidAccount = true;
        this.setRespData.cid = e.cid;
        this.custLoginModel.cid = this.setRespData.cid;
        this.setRespData.consultantID = e.consultantID;
        if (this.setRespData.cid > 0) {
          // this.commonAPI.fnGetCustomerLogoURL(this.setRespData.cid, 2);
          this.getImgLogo = localStorage.getItem(this.enc.encryptUsingAES256('customerLogoURL'));
          this.isShowImgLogo = true;
        } else {
          this.isShowImgLogo = false;
        }
      } else if (e && e.cid) {
        this.isValidAccount = false;
        this.setRespData.cid = e.cid;
        this.custLoginModel.cid = this.setRespData.cid;
        if (this.setRespData.cid > 0) {
          // this.commonAPI.fnGetCustomerLogoURL(this.setRespData.cid, 2);
          this.getImgLogo = localStorage.getItem(this.enc.encryptUsingAES256('customerLogoURL'));
          this.isShowImgLogo = true;
        } else {
          this.isShowImgLogo = false;
        }
      } else if (e) {
        this.isShowImgLogo = false;
      } else {
        this.isValidAccount = false;
      }
    }
  }

  config: NgOtpInputConfig = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: ''
  };
  onOtpChange(e) {
    this.otpModal.otp = e;
    // console.log(e);
  }
  resendDisabled = true;
  timer = 20;
  intervalRef: any;

}





const routes: Routes = [
  { path: 'login', component: LoginFormComponent },
  { path: 'login/:cid', component: LoginFormComponent }
];
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DxButtonModule,
    DxCheckBoxModule,
    DxTextBoxModule,
    DxFormModule,
    FormsModule,
    DxTooltipModule,
    RouterModule.forChild(routes),
    NgxSpinnerModule,
    CoreModule,
    ForgotPasswordVerifyModule,
    ESSAccountVerifyModule,
    ESSNewPasswordModule,
    DxPopupModule,
    DxLoadIndicatorModule,
    NgOtpInputModule
  ],
  declarations: [LoginFormComponent],
  exports: [LoginFormComponent]
})
export class LoginFormModule { }

